import AiSearchPage from './components/AiSearchPage';
import {
    AiSearchProfilePopoutContext,
    useAiSearchProfilePopoutContextProvider,
} from './components/AiSearchProfilePopout/AiSearchProfilePopoutContext';
import {
    OutreachCandidatePopoutContext,
    useOutreachCandidatePopoutContextProvider,
} from './components/ShortlistedList/Outreach/OutreachContext';
import ShortlistedPageContent from './components/ShortlistedList/ShortlistedPageContent';
import {
    ShortlistedListContext,
    useShortlistedListContextProvider,
} from './components/ShortlistedList/utils/ShortlistedListContext';

const ShortlistedAiSearchPage = () => {
    return (
        <AiSearchPage>
            <AiSearchProfilePopoutContext.Provider value={useAiSearchProfilePopoutContextProvider()}>
                <ShortlistedListContext.Provider value={useShortlistedListContextProvider()}>
                    <OutreachCandidatePopoutContext.Provider value={useOutreachCandidatePopoutContextProvider()}>
                        <ShortlistedPageContent />
                    </OutreachCandidatePopoutContext.Provider>
                </ShortlistedListContext.Provider>
            </AiSearchProfilePopoutContext.Provider>
        </AiSearchPage>
    );
};

export default ShortlistedAiSearchPage;
